<dx-tab-panel [dataSource]="pages"
              [selectedIndex]="0"
              class="p-2 np-inner-tab-panel"
              [showNavButtons]="true"
              [scrollingEnabled]="true"
              [scrollByContent]="false"
              [swipeEnabled]="false"
              style="height: 100%;">
    
<div *dxTemplate="let company of 'legalGeneralTemplate'">
    <div class="np-form-control dx-fieldset">
      <dx-validation-group id="LEGAL">
        <dx-box class="gap-4 mb-4" direction="row" crossAlign="stretch" width="100%">
    
          <dxi-item [ratio]="1">
    
            <div class="dx-card mb-4">
              <div class="dx-fieldset d-flex flex-column gap-4">
                <div class="dx-fieldset-header">
                  {{ 'Produktsicherheitsverordnung (GPSR)' | translate }}
                    <dx-button *ngIf="loginService.hasAddonDataSources && !templateView"
                               stylingMode="text"catal
                               (onClick)="jumpToDataSources()"
                               text="{{ 'Neue Datenquelle anlegen' | translate }}"
                               type="default" style="min-width: 32px;">
                    </dx-button>
                </div>
    
                  <div >
                    <div class="np-field">
                      <np-inputControl [(model)]="model"
                                       [(productTranslation)]="productTranslation"
                                       [showLinkButtons]="showLinkButtons"
                                       [showPlaceLabel]="model?.legalCharacteristic?.contact?.length > 0"
                                       [suppressTranslation]="false"
                                       [suppressPlaceLabel]="true"
                                       [(selectedElements)]="selectedElements"
                                       (elementSelected)="elementSelectFunction($event)"
                                       (onValueChanged)="update($event)"
                                       labelText="{{ 'Ansprechpartner' | translate }}"
                                       [showDragHandle]="showDragHandle"
                                       [dragFilter]="dragFilter"
                                       (excelElementDropped)="excelElementDrop($event)"
                                       [isPrint]="isPrint"
                                       field="PRODUCT_SAFETY_CONTACT"
                                       [showHTMLSwitch]="showHTMLSwitch"
                                       [(showHTMLEditor)]="showHTMLEditor"
                                       (showHTMLEditorChange)="showHTMLEditorChanged()">
                        <div slot="content" class="contentSlot">
                          <div *ngIf="showHTMLEditor && !isPrint" class="w-100">
                            <dx-html-editor class="w-100"
                                            [multiline]="false"
                                            [height]="400"
                                            [(value)]="model.legalCharacteristic.contact"
                                            placeholder="PRODUCT_SAFETY_CONTACT"
                                            (onFocusOut)="update($event, 'PRODUCT_SAFETY_CONTACT')"
                                            allowSoftLineBreak="true"
                                            [disabled]="loginService.hasAddonDataSources"
                                            >
                              <dxo-toolbar>
                                <dxi-item name="bold"></dxi-item>
                                <dxi-item name="italic"></dxi-item>
                                <dxi-item name="underline"></dxi-item>
                                <dxi-item name="separator"></dxi-item>
                                <dxi-item name="alignLeft"></dxi-item>
                                <dxi-item name="alignCenter"></dxi-item>
                                <dxi-item name="alignRight"></dxi-item>
                                <dxi-item name="alignJustify"></dxi-item>
                                <dxi-item name="separator"></dxi-item>
                                <dxi-item name="header" [acceptedValues]="[1, 2, 3, 4, 5, false]"></dxi-item>
                                <dxi-item name="separator"></dxi-item>
                                <dxi-item name="orderedList"></dxi-item>
                                <dxi-item name="bulletList"></dxi-item>
                                <dxi-item name="separator"></dxi-item>
                                <dxi-item name="link"></dxi-item>
                              </dxo-toolbar>
                              <dx-validator *ngIf="!templateView"
                                            validationGroup="LEGAL"
                                            (onInitialized)="validationService.startAutomaticValidation($event)">
                                <dxi-validation-rule type="async"
                                                     [validationCallback]="validationService.validateField('PRODUCT_SAFETY_CONTACT')"></dxi-validation-rule>
                              </dx-validator>
                            </dx-html-editor>
                          </div>
    
                          <div *ngIf="!showHTMLEditor || isPrint">
                            <label class="placeLabel {{ model?.contact?.length > 0 ? 'placeLabelSmall' : '' }}">CONTACT</label>
                            <dx-text-area [(value)]="model.legalCharacteristic.contact"
                                          [height]="250"
                                          [readOnly]="true"
                                          (onValueChanged)="update($event, 'PRODUCT_SAFETY_CONTACT')">
                              <dx-validator *ngIf="!templateView"
                                            validationGroup="LEGAL"
                                            (onInitialized)="validationService.startAutomaticValidation($event)">
                                <dxi-validation-rule type="async"
                                                     [validationCallback]="validationService.validateField('PRODUCT_SAFETY_CONTACT')"></dxi-validation-rule>
                              </dx-validator>
                            </dx-text-area>
                          </div>
                        </div>
    
                        <div *ngIf="hasTranslation" slot="translation" class="translationSlot">
                          <div *ngIf="showHTMLEditor">
                            <dx-html-editor [(value)]="productTranslation.contact"
                                            placeholder="PRODUCT_SAFETY_CONTACT"
                                            (onValueChanged)="translationUpdate(model.legalCharacteristic.contact, $event.value)"
                                            [disabled]="loginService.hasAddonDataSources">
                              <dxo-toolbar>
                                <dxi-item name="undo"></dxi-item>
                                <dxi-item name="redo"></dxi-item>
                                <dxi-item name="separator"></dxi-item>
                                <dxi-item name="bold"></dxi-item>
                                <dxi-item name="italic"></dxi-item>
                                <dxi-item name="strike"></dxi-item>
                                <dxi-item name="underline"></dxi-item>
                                <dxi-item name="separator"></dxi-item>
                                <dxi-item name="alignLeft"></dxi-item>
                                <dxi-item name="alignCenter"></dxi-item>
                                <dxi-item name="alignRight"></dxi-item>
                                <dxi-item name="alignJustify"></dxi-item>
                                <dxi-item name="separator"></dxi-item>
                                <dxi-item name="header" [acceptedValues]="[1, 2, 3, 4, 5, false]"></dxi-item>
                                <dxi-item name="separator"></dxi-item>
                                <dxi-item name="orderedList"></dxi-item>
                                <dxi-item name="bulletList"></dxi-item>
                                <dxi-item name="separator"></dxi-item>
                                <dxi-item name="link"></dxi-item>
                              </dxo-toolbar>
                              <dx-validator *ngIf="!templateView"
                                            validationGroup="LEGAL"
                                            (onInitialized)="validationService.startAutomaticValidation($event)">
                                <dxi-validation-rule type="custom"
                                                     [validationCallback]="validationService.validateField('PRODUCT_SAFETY_CONTACT')"></dxi-validation-rule>
                              </dx-validator>
                            </dx-html-editor>
                          </div>
    
                          <div *ngIf="!showHTMLEditor">
                            <label class="placeLabel {{ productTranslation?.contact?.length > 0 ? 'placeLabelSmall' : '' }}">
                              CONTACT
                            </label>
                            <dx-text-area [(value)]="productTranslation.contact"
                                          [height]="130"
                                          (onValueChanged)="translationUpdate(model.legalCharacteristic.contact, $event.value)"
                                          [readOnly]="readOnly('productSafetyContact')">
                              <dx-validator *ngIf="!templateView"
                                            validationGroup="LEGAL"
                                            (onInitialized)="validationService.startAutomaticValidation($event)">
                                <dxi-validation-rule type="async"
                                                     [validationCallback]="validationService.validateField('PRODUCT_SAFETY_CONTACT')"></dxi-validation-rule>
                              </dx-validator>
                            </dx-text-area>
                          </div>
                        </div>
                      </np-inputControl>
    
                    </div>
                  </div>
              </div>
            </div>
          </dxi-item>
          <dxi-item [ratio]="1">
              <div class="dx-card mb-4" *ngIf="loginService.hasAddonLegalBiozidRelevant">
              <div class="dx-fieldset d-flex flex-column gap-4">
                <np-inputControl [(model)]="model"
                                 [showLinkButtons]="showLinkButtons"
                                 [suppressPlaceLabel]="true"
                                 [(selectedElements)]="selectedElements"
                                 (elementSelected)="elementSelectFunction($event)"
                                 (onValueChanged)="update($event)"
                                 labelText="{{ 'Biozidbehandeltes Produkt' | translate }}"
                                 field="IS_BIOCIDAL_PRODUCT"
                                 [showDragHandle]="showDragHandle"
                                 [dragFilter]="dragFilter"
                                 (excelElementDropped)="excelElementDrop($event)">
                  <div slot="content" class="contentSlot np-others">
                    <np-booleanRadioGroup [(value)]="model.legalCharacteristic.isBiocidalProduct"
                                          [templateView]="templateView"
                                          [readOnly]="readOnlyForLinkedFields('IS_BIOCIDAL_PRODUCT') || readOnly('legalBiocidalProduct')"
                                          [fieldName]="validationService.fieldNames.isBiocidalProduct"
                                          (onValueChanged)="update($event, 'IS_BIOCIDAL_PRODUCT')"
                                          validatorValidationGroup="LEGAL"></np-booleanRadioGroup>
                  </div>
                </np-inputControl>
    
                <hr *ngIf="model?.legalCharacteristic?.isBiocidalProduct" />
    
                <np-inputControl *ngIf="model?.legalCharacteristic?.isBiocidalProduct"
                                 [(model)]="model"
                                 [showLinkButtons]="showLinkButtons"
                                 [showPlaceLabel]="model?.legalCharacteristic?.biocidalFeature?.length > 0"
                                 [suppressLinkButton]="false"
                                 [(selectedElements)]="selectedElements"
                                 (elementSelected)="elementSelectFunction($event)"
                                 (onValueChanged)="update($event)"
                                 labelText="{{ 'Biozide Eigenschaft' | translate }}"
                                 field="BIOCIDAL_FEATURE"
                                 [showDragHandle]="showDragHandle"
                                 [dragFilter]="dragFilter"
                                 (excelElementDropped)="excelElementDrop($event)">
                  <div slot="content" class="contentSlot">
                    <dx-text-box [(value)]="model.legalCharacteristic.biocidalFeature"
                                 [readOnly]="readOnlyForLinkedFields('BIOCIDAL_FEATURE') || readOnly('legalBiocidalProduct')"
                                 [showClearButton]="true"
                                 (onValueChanged)="update($event, 'BIOCIDAL_FEATURE')">
                      <dx-validator *ngIf="!templateView"
                                    validationGroup="LEGAL"
                                    (onInitialized)="validationService.startAutomaticValidation($event)">
                        <dxi-validation-rule type="async"
                                             [validationCallback]="validationService.validateField('BIOCIDAL_FEATURE')"></dxi-validation-rule>
                      </dx-validator>
                    </dx-text-box>
                  </div>
                </np-inputControl>
    
                <np-inputControl *ngIf="model?.legalCharacteristic?.isBiocidalProduct"
                                 [(model)]="model"
                                 [showLinkButtons]="showLinkButtons"
                                 [showPlaceLabel]="model?.legalCharacteristic?.biocidalIngredient?.length > 0"
                                 [suppressLinkButton]="false"
                                 [(selectedElements)]="selectedElements"
                                 (elementSelected)="elementSelectFunction($event)"
                                 (onValueChanged)="update($event)"
                                 labelText="{{ 'Wirkstoff' | translate }}"
                                 field="BIOCIDAL_INGREDIENT"
                                 [showDragHandle]="showDragHandle"
                                 [dragFilter]="dragFilter"
                                 (excelElementDropped)="excelElementDrop($event)">
                  <div slot="content" class="contentSlot">
                    <dx-text-box [(value)]="model.legalCharacteristic.biocidalIngredient"
                                 [readOnly]="readOnlyForLinkedFields('BIOCIDAL_INGREDIENT') || readOnly('legalBiocidalProduct')"
                                 [showClearButton]="true"
                                 (onValueChanged)="update($event, 'BIOCIDAL_INGREDIENT')">
                      <dx-validator *ngIf="!templateView"
                                    validationGroup="LEGAL"
                                    (onInitialized)="validationService.startAutomaticValidation($event)">
                        <dxi-validation-rule type="async"
                                             [validationCallback]="validationService.validateField('BIOCIDAL_INGREDIENT')"></dxi-validation-rule>
                      </dx-validator>
                    </dx-text-box>
                  </div>
                </np-inputControl>
              </div>
            </div>
              <div class="dx-card mb-4" *ngIf="loginService.hasAddonLegalWeeeRelevant">
              <div class="dx-fieldset d-flex flex-column gap-4">
                <np-inputControl [(model)]="model"
                                 [direction]="templateView ? 'column' : 'row'"
                                 [showLinkButtons]="showLinkButtons"
                                 [suppressPlaceLabel]="true"
                                 [(selectedElements)]="selectedElements"
                                 (elementSelected)="elementSelectFunction($event)"
                                 (onValueChanged)="update($event)"
                                 labelText="{{ 'WEEE ROHS EAR relevant' | translate }}"
                                 field="IS_WEEE_ROHS_EAR"
                                 [showDragHandle]="showDragHandle"
                                 [dragFilter]="dragFilter"
                                 (excelElementDropped)="excelElementDrop($event)">
                  <div slot="content" class="contentSlot np-others">
                    <np-booleanRadioGroup [(value)]="model.legalCharacteristic.isWeeeRohsEar"
                                          [templateView]="templateView"
                                          [readOnly]="readOnlyForLinkedFields('IS_WEEE_ROHS_EAR') || readOnly('legalWEEROHSEAR')"
                                          [fieldName]="validationService.fieldNames.isWeeeRohsEar"
                                          (onValueChanged)="update($event, 'IS_WEEE_ROHS_EAR')"
                                          validatorValidationGroup="LEGAL"></np-booleanRadioGroup>
                  </div>
                </np-inputControl>
    
                <hr *ngIf="model?.legalCharacteristic?.isWeeeRohsEar" />
    
                <np-inputControl *ngIf="model?.legalCharacteristic?.isWeeeRohsEar"
                                 [(model)]="model"
                                 [showLinkButtons]="showLinkButtons"
                                 [showPlaceLabel]="model?.legalCharacteristic?.weeeDeviceType?.length > 0"
                                 [suppressLinkButton]="false"
                                 [(selectedElements)]="selectedElements"
                                 (elementSelected)="elementSelectFunction($event)"
                                 (onValueChanged)="update($event)"
                                 labelText="{{ 'Geräteart' | translate }}"
                                 field="WEEE_DEVICE_TYPE"
                                 [showDragHandle]="showDragHandle"
                                 [dragFilter]="dragFilter"
                                 (excelElementDropped)="excelElementDrop($event)">
                  <div slot="content" class="contentSlot">
                    <np-dropdown-control fieldName="WEEE_DEVICE_TYPE"
                                         [readOnly]="readOnlyForLinkedFields('WEEE_DEVICE_TYPE') || readOnly('weeeDeviceType')"
                                         [templateView]="templateView"
                                         validationGroup="LEGAL"
                                         [validationCallback]="validationService.validateField('WEEE_DEVICE_TYPE')"
                                         [items]="weeeDeviceTypes"
                                         [(value)]="model.legalCharacteristic.weeeDeviceType"
                                         (valueChange)="update($event, 'WEEE_DEVICE_TYPE')"
                                         (onValueChanged)="update($event, 'WEEE_DEVICE_TYPE')"
                                         (onCustomItemCreating)="onCustomItemCreating($event, 'weeeDeviceType')"></np-dropdown-control>
    
                  </div>
                </np-inputControl>
    
                <np-inputControl *ngIf="model?.legalCharacteristic?.isWeeeRohsEar"
                                 [(model)]="model"
                                 [showLinkButtons]="showLinkButtons"
                                 [showPlaceLabel]="model?.legalCharacteristic?.weeeNumber?.length > 0"
                                 [suppressLinkButton]="false"
                                 [(selectedElements)]="selectedElements"
                                 (elementSelected)="elementSelectFunction($event)"
                                 (onValueChanged)="update($event)"
                                 labelText="{{ 'WEEE-Nummer' | translate }}"
                                 field="WEEE_NUMBER"
                                 [showDragHandle]="showDragHandle"
                                 [dragFilter]="dragFilter"
                                 (excelElementDropped)="excelElementDrop($event)">
                  <div slot="content" class="contentSlot">
                    <dx-text-box [(value)]="model.legalCharacteristic.weeeNumber"
                                 [readOnly]="readOnlyForLinkedFields('WEEE_NUMBER') || readOnly('weeeNumber')"
                                 [showClearButton]="true"
                                 (onValueChanged)="update($event, 'WEEE_NUMBER')">
                      <dx-validator *ngIf="!templateView"
                                    validationGroup="LEGAL"
                                    (onInitialized)="validationService.startAutomaticValidation($event)">
                        <dxi-validation-rule type="async"
                                             [validationCallback]="validationService.validateField('WEEE_NUMBER')"></dxi-validation-rule>
                      </dx-validator>
                    </dx-text-box>
                  </div>
                </np-inputControl>
              </div>
            </div>
            <div class="dx-card">
                <div class="dx-fieldset d-flex flex-column gap-4">
                    <np-inputControl *ngIf="loginService.hasAddonLegalCegsRelevant"
                                     [(model)]="model"
                                 [direction]="templateView ? 'column' : 'row'"
                                 [showLinkButtons]="showLinkButtons"
                                 [suppressPlaceLabel]="true"
                                 [(selectedElements)]="selectedElements"
                                 (elementSelected)="elementSelectFunction($event)"
                                 (onValueChanged)="update($event)"
                                 labelText="{{ 'CE GS relevantes Produkt' | translate }}"
                                 field="IS_CE_GS"
                                 [showDragHandle]="showDragHandle"
                                 [dragFilter]="dragFilter"
                                 (excelElementDropped)="excelElementDrop($event)">
                  <div slot="content" class="contentSlot np-others">
                    <np-booleanRadioGroup [(value)]="model.legalCharacteristic.isCeGs"
                                          [templateView]="templateView"
                                          [readOnly]="readOnlyForLinkedFields('IS_CE_GS') || readOnly('legalCeGs')"
                                          [fieldName]="validationService.fieldNames.isCeGs"
                                          (onValueChanged)="update($event, 'IS_CE_GS')"
                                          validatorValidationGroup="LEGAL"></np-booleanRadioGroup>
                  </div>
                </np-inputControl>
                    <np-inputControl *ngIf="loginService.hasAddonLegalReachRelevant"
                                     [(model)]="model"
                                 [direction]="templateView ? 'column' : 'row'"
                                 [showLinkButtons]="showLinkButtons"
                                 [suppressPlaceLabel]="true"
                                 [(selectedElements)]="selectedElements"
                                 (elementSelected)="elementSelectFunction($event)"
                                 (onValueChanged)="update($event)"
                                 labelText="{{ 'REACH relevant' | translate }}"
                                 field="IS_REACH"
                                 [showDragHandle]="showDragHandle"
                                 [dragFilter]="dragFilter"
                                 (excelElementDropped)="excelElementDrop($event)">
                  <div slot="content" class="contentSlot np-others">
                    <np-booleanRadioGroup [(value)]="model.legalCharacteristic.isReach"
                                          [templateView]="templateView"
                                          [readOnly]="readOnlyForLinkedFields('IS_REACH') || readOnly('legalReach')"
                                          [fieldName]="validationService.fieldNames.isReach"
                                          (onValueChanged)="update($event, 'IS_REACH')"
                                          validatorValidationGroup="LEGAL"></np-booleanRadioGroup>
                  </div>
                </np-inputControl>
                <np-inputControl [(model)]="model"
                                 [direction]="templateView ? 'column' : 'row'"
                                 [showLinkButtons]="showLinkButtons"
                                 [suppressPlaceLabel]="true"
                                 [(selectedElements)]="selectedElements"
                                 (elementSelected)="elementSelectFunction($event)"
                                 (onValueChanged)="update($event)"
                                 labelText="{{ 'Sicherheitsdatenblatt erforderlich' | translate }}"
                                 field="IS_SECURITY_DATASHEET_NEEDED"
                                 [showDragHandle]="showDragHandle"
                                 [dragFilter]="dragFilter"
                                 (excelElementDropped)="excelElementDrop($event)">
                  <div slot="content" class="contentSlot np-others">
                      <np-booleanRadioGroup
                          [value]="safetyDataSheetNeeded"
                                          [templateView]="templateView"
                          [readOnly]="true"
                          [showNullValue]="false"
                                          [fieldName]="validationService.fieldNames.isSecurityDatasheetNeeded"
                                          (onValueChanged)="update($event, 'IS_SECURITY_DATASHEET_NEEDED')"
                                          validatorValidationGroup="LEGAL"></np-booleanRadioGroup>
                  </div>
                </np-inputControl>
    
                    <np-inputControl *ngIf="loginService.hasAddonLegalEnergyclassAdministration"
                                     [(model)]="model"
                                     [direction]="templateView ? 'column' : 'row'"
                                     [showLinkButtons]="showLinkButtons"
                                     [suppressPlaceLabel]="true"
                                     [(selectedElements)]="selectedElements"
                                     (elementSelected)="elementSelectFunction($event)"
                                     (onValueChanged)="update($event)"
                                     labelText="{{ 'Energieeffizienzklasse' | translate }}"
                                     [field]="validationService.fieldNames.energyEfficiencyClass"
                                     [showDragHandle]="showDragHandle"
                                     [dragFilter]="dragFilter"
                                     (excelElementDropped)="excelElementDrop($event)">
                        <div slot="content" class="contentSlot np-others">
                            <dx-select-box
                                [dataSource]="energyEfficiencyClassValues"
                                [(value)]="model.legalCharacteristic.energyEfficiencyClass"
                                (onValueChanged)="update($event, validationService.fieldNames.energyEfficiencyClass)"
                                validatorValidationGroup="LEGAL">
                                <dx-validator *ngIf="!templateView"
                                              validationGroup="LEGAL"
                                              (onInitialized)="validationService.startAutomaticValidation($event)">
                                    <dxi-validation-rule type="async"
                                                         [validationCallback]="validationService.validateField(validationService.fieldNames.energyEfficiencyClass)"></dxi-validation-rule>
                                </dx-validator>
                            </dx-select-box>
                        </div>
                    </np-inputControl>
    
                    <div *ngIf="loginService.hasAddonLegalBatterylawRelevant">
                        <np-inputControl
                            [(model)]="model"
                                 [direction]="templateView ? 'column' : 'row'"
                                 [showLinkButtons]="showLinkButtons"
                                 [suppressPlaceLabel]="true"
                                 [(selectedElements)]="selectedElements"
                                 (elementSelected)="elementSelectFunction($event)"
                                 (onValueChanged)="update($event)"
                                 labelText="{{ 'BattG relevant' | translate }}"
                                 field="IS_BATTERIE_V"
                                 [showDragHandle]="showDragHandle"
                                 [dragFilter]="dragFilter"
                                 (excelElementDropped)="excelElementDrop($event)">
                  <div slot="content" class="contentSlot np-others">
                    <np-booleanRadioGroup [(value)]="model.legalCharacteristic.isBatterieV"
                                          [templateView]="templateView"
                                          [readOnly]="readOnlyForLinkedFields('IS_BATTERIE_V') || readOnly('legalBatterieV')"
                                          [fieldName]="validationService.fieldNames.isBatterieV"
                                          (onValueChanged)="update($event, 'IS_BATTERIE_V')"
                                          validatorValidationGroup="LEGAL"></np-booleanRadioGroup>
                  </div>
                        </np-inputControl>
    
                        <np-inputControl *ngIf="model?.legalCharacteristic?.isBatterieV"
                                         [(model)]="model"
                                         [showLinkButtons]="showLinkButtons"
                                         [showPlaceLabel]="model?.legalCharacteristic?.battGRegistrationNumber?.length > 0"
                                         [suppressLinkButton]="false"
                                         [(selectedElements)]="selectedElements"
                                         (elementSelected)="elementSelectFunction($event)"
                                         (onValueChanged)="update($event)"
                                         labelText="{{ 'BattG-Registrierungsnummer' | translate }}"
                                         field="BATTG_REGISTRATION_NUMBER"
                                         [showDragHandle]="showDragHandle"
                                         [dragFilter]="dragFilter"
                                         (excelElementDropped)="excelElementDrop($event)">
                            <div slot="content" class="contentSlot">
                                <dx-text-box [(value)]="model.legalCharacteristic.battGRegistrationNumber"
                                             [readOnly]="readOnlyForLinkedFields('BATTG_REGISTRATION_NUMBER') || readOnly('battGRegistrationNumber')"
                                             [showClearButton]="true"
                                             (onValueChanged)="update($event, 'BATTG_REGISTRATION_NUMBER')">
                                    <dx-validator *ngIf="!templateView"
                                                  validationGroup="LEGAL"
                                                  (onInitialized)="validationService.startAutomaticValidation($event)">
                                        <dxi-validation-rule type="async"
                                                             [validationCallback]="validationService.validateField('BATTG_REGISTRATION_NUMBER')">
                                        </dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-box>
                            </div>
                        </np-inputControl>
                        
                        <div *ngIf="loginService.hasAddonLegalBatterylawRelevant">
                        <np-inputControl
                            [(model)]="model"
                            [direction]="templateView ? 'column' : 'row'"
                            [showLinkButtons]="showLinkButtons"
                            [suppressPlaceLabel]="true"
                            [field]="validationService.fieldNames.legalBatteryIncluded"
                            [(selectedElements)]="selectedElements"
                            (elementSelected)="elementSelectFunction($event)"
                            (onValueChanged)="update($event)"
                            labelText="{{ 'Batterie enthalten' | translate }}"
                            [showDragHandle]="showDragHandle"
                            [dragFilter]="dragFilter"
                            (excelElementDropped)="excelElementDrop($event)">
                            <div slot="content" class="contentSlot np-others">
                                <np-booleanRadioGroup [(value)]="model.legalCharacteristic.batteryIncluded"
                                                      [templateView]="templateView"
                                                      [fieldName]="validationService.fieldNames.legalBatteryIncluded"
                                                      (onValueChanged)="update($event, validationService.fieldNames.legalBatteryIncluded)"
                                                      validatorValidationGroup="LEGAL"></np-booleanRadioGroup>
                            </div>
                        </np-inputControl>
                        <np-inputControl
                            [(model)]="model"
                            [direction]="templateView ? 'column' : 'row'"
                            [showLinkButtons]="showLinkButtons"
                            [suppressPlaceLabel]="true"
                            [(selectedElements)]="selectedElements"
                            [field]="validationService.fieldNames.legalAkkuIncluded"
                            (elementSelected)="elementSelectFunction($event)"
                            (onValueChanged)="update($event)"
                            labelText="{{ 'Akku enthalten' | translate }}"
                            [showDragHandle]="showDragHandle"
                            [dragFilter]="dragFilter"
                            (excelElementDropped)="excelElementDrop($event)">
                            <div slot="content" class="contentSlot np-others">
                                <np-booleanRadioGroup [(value)]="model.legalCharacteristic.akkuIncluded"
                                                      [templateView]="templateView"
                                                      [fieldName]="validationService.fieldNames.legalAkkuIncluded"
                                                      (onValueChanged)="update($event, validationService.fieldNames.legalAkkuIncluded)"
                                                      validatorValidationGroup="LEGAL"></np-booleanRadioGroup>
                            </div>
                        </np-inputControl>
                        </div>
    
                    </div>
                    <np-inputControl *ngIf="loginService.hasAddonLegalWarrantyclass"
                                     [(model)]="model"
                                 direction="row"
                                 [showLinkButtons]="showLinkButtons"
                                 [showPlaceLabel]="model?.productLogistic?.warrantyClassId?.length > 0"
                                 [(selectedElements)]="selectedElements"
                                 (elementSelected)="elementSelectFunction($event)"
                                 (onValueChanged)="update($event)"
                                 labelText="{{ 'Garantieklasse' | translate }}"
                                 field="WARRANTY_CLASS"
                                 [showDragHandle]="showDragHandle"
                                 [dragFilter]="dragFilter"
                                 (excelElementDropped)="excelElementDrop($event)">
                  <div slot="content" class="contentSlot">
                    <dx-select-box [items]="warrantyClasses"
                                   placeholder=""
                                   [showClearButton]="showClearButton()"
                                   displayExpr="name"
                                   valueExpr="id"
                                   [searchEnabled]="true"
                                   [(value)]="model.productLogistic.warrantyClassId"
                                   [readOnly]="readOnlyForLinkedFields('WARRANTY_CLASS') || readOnly('legalWarrantyClass')"
                                   noDataText="{{ 'Keine Garantieklassen angelegt.' | translate }}"
                                   (onValueChanged)="update($event, 'WARRANTY_CLASS')">
                      class="hint">
                      <dx-validator *ngIf="!templateView"
                                    validationGroup="LEGAL"
                                    (onInitialized)="validationService.startAutomaticValidation($event)">
                        <dxi-validation-rule type="async"
                                             [validationCallback]="validationService.validateField('WARRANTY_CLASS')"></dxi-validation-rule>
                      </dx-validator>
                    </dx-select-box>
                  </div>
                </np-inputControl>
    
                    <div class="dx-card" *ngIf="loginService.hasAddonLegalStationaryMerchant">
                        <div class="dx-fieldset d-flex flex-column gap-4">
                    <np-inputControl [(model)]="model"
                                     [direction]="templateView ? 'column' : 'row'"
                                     [showLinkButtons]="showLinkButtons"
                                     [suppressPlaceLabel]="true"
                                     [(selectedElements)]="selectedElements"
                                     (elementSelected)="elementSelectFunction($event)"
                                     (onValueChanged)="update($event)"
                                     [field]="validationService.fieldNames.legalSubjectToTax"
                                     labelText="{{ 'Abgabepflichtig' | translate }}"
                                     [showDragHandle]="showDragHandle"
                                     [dragFilter]="dragFilter"
                                     (excelElementDropped)="excelElementDrop($event)">
                        <div slot="content" class="contentSlot np-others">
                            <np-booleanRadioGroup
                                [(value)]="model.legalCharacteristic.subjectToTax"
                                [templateView]="templateView"
                                [fieldName]="validationService.fieldNames.legalSubjectToTax"
                                (onValueChanged)="update($event, 'SUBJECT_TO_TAX')"
                                validatorValidationGroup="LEGAL"></np-booleanRadioGroup>
                        </div>
                    </np-inputControl>
    
                            <np-inputControl [(model)]="model"
                                             [direction]="templateView ? 'column' : 'row'"
                                             [showLinkButtons]="showLinkButtons"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             [field]="validationService.fieldNames.legalFreelyAvailable"
                                             labelText="{{ 'Frei verfügbar' | translate }}"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot np-others">
                                    <np-booleanRadioGroup
                                        [(value)]="model.legalCharacteristic.freelyAvailable"
                                        [templateView]="templateView"
                                        [fieldName]="validationService.fieldNames.legalFreelyAvailable"
                                        (onValueChanged)="update($event, 'FREELY_AVAILABLE')"
                                        validatorValidationGroup="LEGAL"></np-booleanRadioGroup>
                                </div>
                            </np-inputControl>
                        </div>
                    </div>
    
    
                    <div class="dx-card" *ngIf="loginService.hasAddonLegalEudrRelevant">
                        <div class="dx-fieldset d-flex flex-column gap-4">
                            <np-inputControl [(model)]="model"
                                             [direction]="templateView ? 'column' : 'row'"
                                             [showLinkButtons]="showLinkButtons"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             [field]="validationService.fieldNames.legalEudrRelevant"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'EUDR-Relevanz' | translate }}"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot np-others">
                                    <np-booleanRadioGroup
                                        [(value)]="model.legalCharacteristic.isEudrRelevant"
                                        [templateView]="templateView"
                                        [fieldName]="validationService.fieldNames.legalEudrRelevant"
                                        (onValueChanged)="update($event, validationService.fieldNames.legalEudrRelevant)"
                                        validatorValidationGroup="LEGAL"></np-booleanRadioGroup>
                                </div>
                            </np-inputControl>
    
                            <np-inputControl *ngIf="model.legalCharacteristic.isEudrRelevant"
                                             [(model)]="model"
                                             [direction]="templateView ? 'column' : 'row'"
                                             [showLinkButtons]="showLinkButtons"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             [field]="validationService.fieldNames.legalEudrReferenceNumber"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'EUDR Referenznummer' | translate }}"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot np-others">
                                    <dx-text-box
                                        [(value)]="model.legalCharacteristic.eudrReferenceNumber"
                                        (onValueChanged)="update($event, validationService.fieldNames.legalEudrReferenceNumber)"
                                        validatorValidationGroup="LEGAL">
                                        <dx-validator *ngIf="!templateView"
                                                      validationGroup="LEGAL"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(validationService.fieldNames.legalEudrReferenceNumber)">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>
                    </div>
    
    
                </div>
            </div>
          </dxi-item>
        </dx-box>
      </dx-validation-group>
    </div>
    </div>

    <div *dxTemplate="let company of 'legalHazmatTemplate'">
        <div class="dx-fieldset d-flex flex-column">
        <div class="np-field">
            <np-inputControl
                [(model)]="model"
                [showLinkButtons]="showLinkButtons"
                [suppressPlaceLabel]="true"
                [(selectedElements)]="selectedElements"
                (elementSelected)="elementSelectFunction($event)"
                (onValueChanged)="update($event)"
                labelText="{{ 'Gefahrgutartikel' | translate }}"
                field="IS_HAZMAT_PRODUCT"
                [showDragHandle]="showDragHandle"
                [dragFilter]="dragFilter"
                (excelElementDropped)="excelElementDrop($event)"
            >
                <div slot="content" class="contentSlot np-others">
                    <np-booleanRadioGroup
                        [(value)]="model.legalCharacteristic.isHazmatProduct"
                        [templateView]="templateView"
                        [fieldName]="validationService.fieldNames.isHazmatProduct"
                        [readOnly]="readOnlyForLinkedFields('IS_HAZMAT_PRODUCT') || readOnly('isHazmatProduct')"
                        (onValueChanged)="update($event, 'IS_HAZMAT_PRODUCT')"
                        validatorValidationGroup="LEGAL"
                    ></np-booleanRadioGroup>
                </div>
            </np-inputControl>
        </div>
        <div *ngIf="model.legalCharacteristic.isHazmatProduct" class="mb-4">            
            <np-inputControl [(model)]="model"
                             direction="row"
                             [showLinkButtons]="showLinkButtons"
                             [showPlaceLabel]="model?.productLogistic?.hazardousMaterialClassId?.length > 0"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Gefahrenstoffklasse' | translate }}"
                             field="HAZMAT_CLASS"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
                <div slot="content" class="contentSlot">
                    <dx-select-box [items]="hazmatClassesWithEmpty"
                                   placeholder=""
                                   [showClearButton]="showClearButton()"
                                   [(value)]="model.productLogistic.hazardousMaterialClassId"
                                   [readOnly]="readOnlyForLinkedFields('HAZMAT_CLASS') || readOnly('legalHazmatClass')"
                                   displayExpr="name"
                                   [searchEnabled]="true"
                                   valueExpr="id"
                                   noDataText="{{ 'Keine Gefahrenstoffklassen angelegt.' | translate }}"
                                   (onValueChanged)="update($event, 'HAZMAT_CLASS')">
                        <dx-validator *ngIf="!templateView"
                                      validationGroup="LEGAL"
                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                            <dxi-validation-rule type="async"
                                                 [validationCallback]="validationService.validateField('HAZMAT_CLASS')">                                
                            </dxi-validation-rule>
                        </dx-validator>
                    </dx-select-box>
                </div>
            </np-inputControl>

            <np-inputControl [suppressPlaceLabel]="true"
                             labelText="{{ 'Signalwort' | translate }}"
                             field="SIGNAL_WORD"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter">
                <div slot="content" class="contentSlot">
                    <np-dropdown-control
                        [items]="hazmatClassService.signalWords"
                        [(value)]="model.legalCharacteristic.signalWord"
                        translationLabelPrefix="SignalWord_"
                        (valueChange)="update($event)"
                        (onValueChanged)="update($event)"
                        [readOnly]="readOnlyForSelectedHazmatClass()"
                    >
                    </np-dropdown-control>
                </div>
            </np-inputControl>

        <dx-tab-panel [dataSource]="hazmatPages" [selectedIndex]="0" class="detailTabs">
            <div *dxTemplate="let piktgramm of 'piktoTemplate'">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-xs-6">
                            <div class="dx-fieldset">
                                <np-inputControl [(model)]="model"
                                                 [(selectedElements)]="selectedElements"
                                                 [showLinkButtons]="showLinkButtons"
                                                 [templateView]="templateView"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 [suppressPlaceLabel]="true"
                                                 [suppressContentWidth]="true"
                                                 direction="column"
                                                 field="HAZARD_PICTOGRAMS"
                                                 labelText="{{ 'Ausgewählt' | translate }}"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <dx-list
                                            #list
                                            [dataSource]="model.legalCharacteristic.hazardPictograms"
                                            selectionMode="multiple"
                                            pageLoadMode="scrollBottom"
                                            noDataText="{{ 'kein Element ausgewählt' | translate }}"
                                            [searchEnabled]="false"
                                            [showSelectionControls]="false"
                                        >
                                            <div *dxTemplate="let item of 'item'">
                                                {{ item }} &nbsp;
                                                <img src="/images/ghs/{{ item }}.png" height="50px" />
                                                &nbsp; {{ item | translate }}
                                            </div>
                                        </dx-list>
                                    </div>
                                </np-inputControl>
                            </div>
                        </div>
                        <div class="col-xs-6">
                            <div class="dx-fieldset">
                                <div class="dx-field">
                                    <h4>{{ 'Mögliche Werte' | translate }}:</h4>
                                </div>
                                <div class="dx-field">
                                    <dx-list [dataSource]="piktoItems"
                                             [keyExpr]="'code'"
                                             selectionMode="multiple"
                                             pageLoadMode="scrollBottom"
                                             [searchEnabled]="true"
                                             [searchExpr]="['code','label']"
                                             [showSelectionControls]="true"
                                             (onSelectionChanged)="update($event)"
                                             [(selectedItemKeys)]="model.legalCharacteristic.hazardPictograms"
                                             [disabled]="readOnlyForSelectedHazmatClass()">
                                        <dxo-search-editor-options placeholder="{{ 'Suchen' | translate }}"></dxo-search-editor-options>
                                        <div *dxTemplate="let item of 'item'">
                                            {{ item.code }} &nbsp;
                                            <img [src]="'/images/ghs/' + item.code + '.png'" height="50px" />
                                            &nbsp; {{ item.label }}
                                        </div>
                                    </dx-list>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *dxTemplate="let company of 'hTemplate'">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-xs-6">
                            <div class="dx-fieldset">
                                <np-inputControl [(model)]="model"
                                                 [(selectedElements)]="selectedElements"
                                                 [showLinkButtons]="showLinkButtons"
                                                 [templateView]="templateView"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 [suppressPlaceLabel]="true"
                                                 [suppressContentWidth]="true"
                                                 direction="column"
                                                 field="HAZARD_STATEMENTS"
                                                 labelText="{{ 'Ausgewählt' | translate }}"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <dx-list
                                            #list
                                            [dataSource]="model.legalCharacteristic.hazardStatements"
                                            selectionMode="multiple"
                                            pageLoadMode="scrollBottom"
                                            noDataText="{{ 'kein Element ausgewählt' | translate }}"
                                            [searchEnabled]="false"
                                            [showSelectionControls]="false"
                                        >
                                            <div *dxTemplate="let item of 'item'">{{ item }} {{ item | translate }}</div>
                                        </dx-list>
                                    </div>
                                </np-inputControl>
                            </div>
                        </div>
                        <div class="col-xs-6">
                            <div class="dx-fieldset">
                                <div class="dx-field">
                                    <h4>{{ 'Mögliche Werte' | translate }}:</h4>
                                </div>
                                <div class="dx-field">
                                    <dx-list [dataSource]="hItems"
                                             [keyExpr]="'code'"
                                             selectionMode="multiple"
                                             pageLoadMode="scrollBottom"
                                             [searchEnabled]="true"
                                             [searchExpr]="['code','label']"
                                             [showSelectionControls]="true"
                                             (onSelectionChanged)="update($event)"
                                             [(selectedItemKeys)]="model.legalCharacteristic.hazardStatements"
                                             [disabled]="readOnlyForSelectedHazmatClass()">
                                        <dxo-search-editor-options placeholder="{{ 'Suchen' | translate }}"></dxo-search-editor-options>
                                        <div *dxTemplate="let item of 'item'">{{ item.code }} {{ item.label }}</div>
                                    </dx-list>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *dxTemplate="let company of 'pTemplate'">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-xs-6">
                            <div class="dx-fieldset">
                                <np-inputControl [(model)]="model"
                                                 [(selectedElements)]="selectedElements"
                                                 [showLinkButtons]="showLinkButtons"
                                                 [templateView]="templateView"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 [suppressPlaceLabel]="true"
                                                 [suppressContentWidth]="true"
                                                 direction="column"
                                                 field="PRECAUTIONARY_STATEMENTS"
                                                 labelText="{{ 'Ausgewählt' | translate }}"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <dx-list
                                            #list
                                            [dataSource]="model.legalCharacteristic.precautionaryStatements"
                                            selectionMode="multiple"
                                            pageLoadMode="scrollBottom"
                                            noDataText="{{ 'kein Element ausgewählt' | translate }}"
                                            [searchEnabled]="false"
                                            [showSelectionControls]="false"
                                        >
                                            <div *dxTemplate="let item of 'item'">{{ item }} {{ item | translate }}</div>
                                        </dx-list>
                                    </div>
                                </np-inputControl>
                            </div>
                        </div>
                        <div class="col-xs-6">
                            <div class="dx-fieldset">
                                <div class="dx-field">
                                    <h4>{{ 'Mögliche Werte' | translate }}:</h4>
                                </div>
                                <div class="dx-field">
                                    <dx-list [dataSource]="pItems"
                                             [keyExpr]="'code'"
                                             selectionMode="multiple"
                                             pageLoadMode="scrollBottom"
                                             [searchEnabled]="true"
                                             [searchExpr]="['code','label']"
                                             [showSelectionControls]="true"
                                             (onSelectionChanged)="update($event)"
                                             [(selectedItemKeys)]="model.legalCharacteristic.precautionaryStatements"
                                             [disabled]="readOnlyForSelectedHazmatClass()">
                                        <dxo-search-editor-options placeholder="{{ 'Suchen' | translate }}"></dxo-search-editor-options>
                                        <div *dxTemplate="let item of 'item'">{{ item.code }} {{ item.label }}</div>
                                    </dx-list>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </dx-tab-panel>
        </div>
    </div>
    </div>
</dx-tab-panel>